import React, { useEffect, useState } from "react";
import NewProfile from "./NewProfile/NewProfile";
import AboutUserProfile from "./AboutUserProfile/AboutUserProfile";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";

export default function SetupProfile() {
  const [ProfileImage, setProfileImage] = useState(null);
  const [profileSection, setProfileSection] = useState(1);
  const [cookies, ,] = useCookies(["token"]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!cookies?.token) {
      navigate("/sign-in");
    }
  }, [cookies]);

  return (
    <div>
      {profileSection === 1 ? (
        <NewProfile
          ProfileImage={ProfileImage}
          setProfileImage={setProfileImage}
          setProfileSection={setProfileSection}
        />
      ) : (
        <AboutUserProfile ProfileImage={ProfileImage} />
      )}
    </div>
  );
}
